import React from 'react';

import BrandPortfolioDesktop from './brand-portfolio/BrandPortfolioDesktop';
import BrandPortfolioMobile from './brand-portfolio/BrandPortfolioMobile';

export default function PortfolioTabs({ data, id, dir }) {
  return (
    <>
      <BrandPortfolioDesktop data={data} dir={dir} id={id} />
      <BrandPortfolioMobile data={data} dir={dir} id={id} />
    </>
  );
}
